import { TradeInPreviewAcquisition } from '@carvana/merch-contracts';
import { useCallback, useContext } from 'react';
import COOKIES from '~/constants/cookies';
import TradeContext from '~/context/common/TradeContext';
import { BrowserCookies } from '~/utilities';

type CommitTradesArgs = {
  selectedTrade: TradeInPreviewAcquisition | null;
  trades: TradeInPreviewAcquisition[];
};

export default function useCommitTrades() {
  const {
    setSelectedTrade,
    trades: { setData }
  } = useContext(TradeContext);

  return useCallback(
    ({ selectedTrade, trades }: CommitTradesArgs) => {
      if (trades.length > 1) {
        const cookieId = BrowserCookies.get(COOKIES.preferredTrade) ?? '';

        if (selectedTrade && selectedTrade.id !== cookieId) {
          BrowserCookies.set(COOKIES.preferredTrade, selectedTrade.id, {
            expires: 365
          });
        }
      } else {
        BrowserCookies.remove(COOKIES.preferredTrade);
      }

      setSelectedTrade(selectedTrade);
      setData(trades);
    },
    [setData, setSelectedTrade]
  );
}
